import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/** Each area's browser-tab title, by path prefix. More specific prefixes come first: the first match wins. */
const TITLES: [prefix: string, title: string][] = [
  ['/login', 'Sign in'],
  ['/activate', 'Set up your account'],
  ['/onboarding/skills', 'Select your skills'],
  ['/onboarding/aspiration', 'Choose your career goal'],
  ['/onboarding/results', 'Your roadmap'],
  ['/home', 'Home'],
  ['/profile', 'Profile'],
  ['/leaderboard', 'Leaderboard'],
  ['/tests', 'Practice tests'],
  ['/roadmap/all', 'All roadmaps'],
  ['/roadmap', 'Roadmap'],
  ['/course', 'Course'],
  ['/mentor-assessment', 'Mentor assessment'],
  ['/mentor', 'Mentor'],
  ['/opportunities', 'Career opportunities'],
  ['/playground', 'Playground'],
  ['/admin/college', 'College admin'],
  ['/admin', 'Admin'],
]

/** "Course · MentorFox" for a page under /course; plain "MentorFox" for the landing page and unknown paths. */
export function pageTitle(pathname: string): string {
  const match = TITLES.find(([prefix]) => pathname === prefix || pathname.startsWith(`${prefix}/`))
  return match ? `${match[1]} · MentorFox` : 'MentorFox'
}

/** Keeps document.title in step with the route, so each page has its own title. */
export function usePageTitle() {
  const { pathname } = useLocation()
  useEffect(() => {
    document.title = pageTitle(pathname)
  }, [pathname])
}
